import React from 'react';
import styles from './Tag.module.less';

export const Tag: React.FC = ({ children }) => (
  <div className={styles.tag}>
    <i className="zola-ui-icon zola-ui-icon-checkmark" />
    {children}
  </div>
);
